
import { defineComponent } from "vue";
import router from "@/router";
import {
  GetMetricData,
  GetMetric,
  SummaryTitleByMonth,
  NumberWithCommas,
  GetHighlight,
  ChangeOverTime,
  SourceURL,
  GetDateFromMonthYear,
} from "@/utils";
import Spinner from "@/components/Spinner.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import FilterTabs from "@/components/Chart/FilterTabs.vue";
import MetricTitle from "@/components/MetricTitle.vue";
import SectionTitle from "@/components/SectionTitle.vue";
import MetricGrid from "@/components/MetricGrid.vue";
import MetricStat from "@/components/MetricStat.vue";
import MetricSource from "@/components/MetricSource.vue";
import MetricHighlight from "@/components/MetricHighlight.vue";
import ChartOptions from "@/types/chartOptions";
import Metric from "@/types/metric";

export default defineComponent({
  data() {
    return {
      data: [],
      monthlyData: [] as Array<any>,
      yearlyData: [] as Array<any>,
      selectedData: [] as Array<any>,
      metric: {} as Metric,
      summaryDate: new Date(),
      latestNumbers: "",
      monthChange: "",
      monthChangePercent: "",
      yearChange: "",
      yearChangePercent: "",
      highlight: "",
      filterOptions: [1, 5, 10, 0],

      //Chart setup
      options: new ChartOptions(),
      dataLabels: ["Annual Michigan Vehicle Production"],
      dataProps: ["michiganmotorvehicleproductionyearly"],
      availableProps: ["michiganmonthlyvehicleproduction", "michiganmotorvehicleproductionyearly" ]
    }
  },
  components: {
    Spinner,
    LineChart,
    MetricTitle,
    SectionTitle,
    FilterTabs,
    MetricGrid,
    MetricStat,
    MetricSource,
    MetricHighlight,
  },
  methods: {
    debug(e: any) {
      console.log("debug", e);
    },
    handleFilter(option: any) {
      this.limitData(option);
    },
    limitData(years: number) {
      /* This is going to be custom for each metric, you need to cin some cases 
        convert the lable to a date. Then limit the date to the intended range */
      if (years == 0) {
        this.dataProps = [this.availableProps[1]];
        this.selectedData = this.yearlyData;
      } else {
        let count = -1 * (12 * years);
        this.dataProps = [this.availableProps[0]];
        this.selectedData = this.monthlyData.slice(count);
      }
    },
    summaryTitle() {
      return SummaryTitleByMonth(this.summaryDate);
    },
    sourceUrl() {
      return SourceURL(this.metric);
    },
  },
  async beforeMount() {
    //@ts-ignore
    const topic = router.currentRoute.value.name; // Get which metric by the route
    this.data = await GetMetricData(topic); // Get raw data from Socrata
    this.metric = GetMetric(topic); // Get metric configuration



    // Data is a combined set of 2 tables so we need to split it out into monthly and yearly data

    this.data.forEach((x:any) => {
        if (x[this.availableProps[1]]) {
          this.yearlyData.push(x);
        } else {
          this.monthlyData.push(x);
        }
    });



    this.selectedData = this.yearlyData; // initialize this to "lifetime" and update this variable when a range is selected


    // Get summary data and hightlights
    const lastItem: any = this.monthlyData[this.monthlyData.length - 1];
    this.summaryDate = GetDateFromMonthYear(lastItem.month);
    this.latestNumbers = NumberWithCommas(lastItem[this.availableProps[0]]);
    this.monthChange = NumberWithCommas(
      ChangeOverTime(this.monthlyData, 1, this.availableProps[0], false)
    );
    this.monthChangePercent = ChangeOverTime(
      this.monthlyData,
      1,
      this.availableProps[0],
      true
    );
    this.yearChange = NumberWithCommas(
      ChangeOverTime(this.monthlyData, 12, this.availableProps[0], false)
    );
    this.yearChangePercent = ChangeOverTime(
      this.monthlyData,
      12,
      this.availableProps[0],
      true
    );
    this.highlight = GetHighlight(this.monthlyData);
  },
});
